// extracted by mini-css-extract-plugin
export default {"tag":"LikeButtonLarge_tag__JMlDF","-active":"LikeButtonLarge_-active__hl8Yw"};